import PageRecord from "models/view-models/page-record";
import { useCallback } from "react";
import usePageErrors from "utilities/hooks/use-page-errors";
import PageService from "utilities/services/notebooks/page-service";

interface UsePagesResult {
    errors: string[];
    createPage: (
        page: PageRecord,
        pathParams: { notebookId: number }
    ) => Promise<PageRecord | undefined>;
}

export default function usePages(): UsePagesResult {
    const { create: createPageApi } = PageService.useCreate();
    const {
        handlePageLoadError,
        pageErrors: errors,
        resetPageErrors,
    } = usePageErrors();

    const createPage = useCallback(
        async (page: PageRecord, pathParams: { notebookId: number }) => {
            try {
                const result = await createPageApi(page, pathParams);
                resetPageErrors();
                return result.resultObject;
            } catch (error) {
                handlePageLoadError(error);
                return undefined;
            }
        },
        [createPageApi, resetPageErrors, handlePageLoadError]
    );

    return {
        errors,
        createPage,
    };
}
